export enum MenuOptions {
  CLASSES = "classes",
  FREE_CLASSES = "free-classes",
  BASIC_CLASSES = "basic-classes",
  PROGRAMS = "programs",
  CATEGORIES = "categories",
  INSTRUCTORS = "instructors",
}
